import { type HttpResponsePayload, createHttpEndpoint } from '../../utils'

/**
 * Given a product id, returns all the data needed to render the goodest finds modal
 * @see {@link https://devportal.backmarket.io/catalog/default/api/product-page-api/definition#tag/goodestFinds/operation/getGoodestFinds}
 */
export const getGoodestFinds = createHttpEndpoint<GetGoodestFindsResponse>({
  method: 'GET',
  operationId: 'getGoodestFinds',
  path: '/bm/product/:productId/goodest-finds',
})

export type GetGoodestFindsResponse = HttpResponsePayload<{
  title: string
  buttons: Array<{
    label: string
    icon: string
    image: string
    paragraphs: Array<{
      title: string
      text: string
      linkToApp?: boolean
    }>
  }>
}>
